import React from "react";
import photo from "../static/media/r-canva.png";
import data from "../static/info/data";
export default function Home() {
  return (
    <div className="home-container" id="home">
      <div className="social">
        <ul className="social-items">
          {data?.socialLinks?.map(
            (item, index) =>
              item.display && (
                <li key={index}>
                  <a href={item.url} target="_blank">
                    <i
                      className={item.iconClass + " text-[22px] sm:text-2xl"}
                    ></i>
                  </a>
                </li>
              )
          )}
        </ul>
      </div>
      <div className="home-img">
        <img
          src={photo}
          alt="image"
          className="rounded-full h-[280px] md:h-[350px] object-cover"
          data-aos="fade-down"
          data-aos-duration="1500"
        />
      </div>
      <div
        className="title p-3 m-3 md:p-5 md:m-7"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <h4 className="text-3xl md:text-4xl  lg:text-[40px] font-semibold tracking-wide">
          {data.homeData.l1}
        </h4>
        <h3 className="text-4xl md:text-5xl lg:text-[56px] my-1 md:my-4 font-bold tracking-wide">
          {data.homeData.l2}
        </h3>
        <h5 className="font-normal text-lg sm:text-xl lg:text-2xl my-2">
          {data.homeData.description}
        </h5>
        <div className="flex items-center justify-center lg:justify-normal gap-4 lg:gap-8">
          <a href={`mailto:${data.email}`}>
            <button className="text-sm sm:text-base lg:text-lg">
              Contact Me&nbsp;<i className="fa fa-envelope"></i>
            </button>
          </a>
          <a className="" href="#resume">
            <button className="sec-button text-sm sm:text-base lg:text-lg">
              View my CV&nbsp;<i className="fa fa-file"></i>
            </button>
          </a>
        </div>
        <div className="arrow-div">
          <a href="#about">
            <svg
              className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium down-arrow css-vubbuv"
              focusable="false"
              aria-hidden="true"
              style={{ width: "10vmin", height: "auto" }}
              viewBox="0 0 24 24"
              data-testid="KeyboardDoubleArrowDownIcon"
            >
              <path d="M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"></path>
              <path d="m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
